"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessToken = exports.GrantType = void 0;
const logger_1 = require("@linq/logger");
const Request_1 = require("./Request");
var GrantType;
(function (GrantType) {
    GrantType["ClientCredentials"] = "client_credentials";
    GrantType["Password"] = "password";
    GrantType["PasswordRealm"] = "http://auth0.com/oauth/grant-type/password-realm";
    GrantType["Refresh"] = "refresh_token";
})(GrantType = exports.GrantType || (exports.GrantType = {}));
class AccessToken {
    constructor(options) {
        this.options = options;
        this.request = new Request_1.Request();
    }
    async getToken() {
        try {
            if (this.token && this.getEpocTime() < this.tokenExpiration) {
                return this.token;
            }
            const response = await this.requestToken();
            if (!response.token) {
                return '';
            }
            this.token = response.token;
            this.tokenExpiration = response.tokenExpiration;
            return this.token;
        }
        catch (e) {
            logger_1.Logger.error('getToken error ', e);
            return '';
        }
    }
    async requestToken() {
        const body = {
            grant_type: this.options.grantType,
            scope: this.options.scope,
            refresh_token: this.options.refreshToken,
        };
        const headers = {};
        if (this.options.basicHeader) {
            const authorization = Buffer.from(`${this.options.clientId}:${this.options.clientSecret}`).toString('base64');
            headers.Authorization = `Basic ${authorization}`;
        }
        else {
            // token authorization grants
            switch (this.options.grantType) {
                case GrantType.Password:
                case GrantType.PasswordRealm:
                    body.username = this.options.username;
                    body.password = this.options.password;
                    body.client_id = this.options.clientId;
                    body.client_secret = this.options.clientSecret;
                    body.audience = this.options.audience;
                    body.realm = this.options.realm;
                    break;
                default:
                    body.client_id = this.options.clientId;
                    body.client_secret = this.options.clientSecret;
                    body.audience = this.options.audience;
            }
        }
        if (this.options.formUrlencoded) {
            headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }
        const response = await this.request.post(this.options.endpoint, body, {
            headers,
        });
        const token = response.data.access_token;
        const tokenExpiration = this.getEpocTime() + Number(response.data.expires_in);
        return {
            token,
            tokenExpiration,
        };
    }
    getEpocTime() {
        return Math.floor(new Date().getTime() / 1000);
    }
}
exports.AccessToken = AccessToken;
//# sourceMappingURL=AccessToken.js.map